import { Baby, BabyDeliveryMode, Gender } from '@snapi/types';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown, Input, BirthdayPicker } from '@snapi/form';

export interface BabyFormProps {
  horizontal?: boolean;
  date: string;
}

export const BabyForm: React.FC<BabyFormProps> = ({ horizontal, date }) => {
  const {
    register,
    formState: { errors, isSubmitting },
    control,
  } = useFormContext<Baby>();

  return (
    <div className="flex flex-1 flex-col gap-8">
      <Input
        label="Name"
        placeholder="Name"
        {...register('name', { required: true })}
        horizontal={horizontal}
        error={errors.name}
        disabled={isSubmitting}
      />
      <Controller
        control={control}
        name="dob"
        render={({ field: { onChange, value } }) => (
          <BirthdayPicker
            label="Birthday"
            dob={date}
            onChange={onChange}
            disabled={isSubmitting}
            horizontal={horizontal}
          />
        )}
      />
      <Controller
        control={control}
        name="gender"
        render={({ field: { onChange, value } }) => (
          <Dropdown
            label="Gender"
            current={value}
            horizontal={horizontal}
            disabled={isSubmitting}
            options={[
              {
                name: 'Boy',
                value: Gender.boy,
              },
              {
                name: 'Girl',
                value: Gender.girl,
              },
              {
                name: 'Prefer not to say',
                value: Gender.other,
              },
            ]}
            onChange={onChange}
          />
        )}
      />
      <Controller
        control={control}
        name="delivery"
        render={({ field: { onChange, value } }) => (
          <Dropdown
            label="Birth mode"
            current={value}
            horizontal={horizontal}
            disabled={isSubmitting}
            options={[
              {
                name: 'Vaginal',
                value: BabyDeliveryMode.vaginal,
              },
              {
                name: 'C-section',
                value: BabyDeliveryMode.caesarean,
              },
              {
                name: 'Prefer not to say',
                value: BabyDeliveryMode.other,
              },
            ]}
            onChange={onChange}
          />
        )}
      />
      <Controller
        control={control}
        name="preterm"
        render={({ field: { onChange, value } }) => (
          <Dropdown
            label="Preterm"
            current={value}
            horizontal={horizontal}
            options={[
              {
                name: 'Yes',
                value: true,
              },
              {
                name: 'No',
                value: false,
              },
            ]}
            disabled={isSubmitting}
            onChange={onChange}
          />
        )}
      />
    </div>
  );
};
